/* ==========================================================================
   PW SEARCH (v67, 6 Oct 2026)
   - Sort select submits on change (form works without JS via noscript button)
   - Show more appends the next page of cards in place (plain link without JS)
   - "/" focuses the visible search field, like the big marketplaces
   ========================================================================== */
(function () {
  'use strict';
  if (window.__pwsInit) return;
  window.__pwsInit = true;

  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }

  ready(function () {
    /* sort */
    document.querySelectorAll('[data-pws-sort] select').forEach(function (s) {
      s.addEventListener('change', function () { s.form.submit(); });
    });

    /* show more */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-pws-more]');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var grid = document.querySelector('[data-pws-grid]');
      var pager = document.querySelector('[data-pws-pager]');
      if (!grid || !pager || !window.fetch || !window.DOMParser) return;
      e.preventDefault();
      if (a.getAttribute('aria-busy') === 'true') return;
      a.setAttribute('aria-busy', 'true');
      var label = a.textContent;
      a.textContent = 'Fetching...';
      fetch(a.href, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var ng = doc.querySelector('[data-pws-grid]');
          var np = doc.querySelector('[data-pws-pager]');
          var first = null;
          if (ng) {
            Array.prototype.slice.call(ng.children).forEach(function (c) {
              c.classList.add('is-new');
              grid.appendChild(c);
              if (!first) first = c;
            });
          }
          if (np) pager.innerHTML = np.innerHTML; else pager.innerHTML = '';
          var pv = pager.querySelector('.pws-prev'); if (pv) pv.remove();
          document.dispatchEvent(new CustomEvent('pws:appended', { detail: { grid: grid } }));
          var link = first && first.querySelector('a[href]');
          if (link) link.focus({ preventScroll: true });
        })
        .catch(function () { window.location.href = a.href; })
        .finally(function () { a.removeAttribute('aria-busy'); a.textContent = label; });
    });

    /* predictive dropdown: Esc closes, arrow keys keep the highlighted row in view */
    document.addEventListener('keyup', function (e) {
      var f = e.target.closest && e.target.closest('.pws-field');
      if (!f) return;
      if (e.key === 'Escape' && typeof f.close === 'function') { f.close(); return; }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        var s = f.querySelector('.pwps [aria-selected="true"]');
        if (s && s.scrollIntoView) s.scrollIntoView({ block: 'nearest' });
      }
    });

    /* predictive dropdown on phones: keep links tappable and fit the dropdown above the keyboard.
       iOS fires focusout before the tap lands, Dawn then closes the dropdown and the tap hits nothing.
       Hold the dropdown open for a moment after a touch or press inside it. */
    function fit(f) {
      var vv = window.visualViewport, h = vv ? vv.height + vv.offsetTop : window.innerHeight;
      var form = f.querySelector('form');
      if (!form) return;
      var m = Math.round(h - form.getBoundingClientRect().bottom - 8);
      f.style.setProperty('--pws-ddmax', Math.max(200, Math.min(m, 640)) + 'px');
    }
    function wire(f) {
      if (!f.__pwsWrapped && typeof f.close === 'function') {
        f.__pwsWrapped = true;
        var orig = f.close.bind(f);
        f.close = function (clear) { if (f.__pwsHold && !clear) return; return orig(clear); };
      }
      if (!f.__pwsSafe && typeof f.updateSearchForTerm === 'function') {
        f.__pwsSafe = true;
        var u = f.updateSearchForTerm.bind(f);
        f.updateSearchForTerm = function (p, n) {
          try { u(p, n); } catch (err) { var t = f.querySelector('[data-predictive-search-search-for-text]'); if (t) t.textContent = 'See all results for “' + n + '”'; }
        };
      }
      if (f.__pwsWired) return;
      f.__pwsWired = true;
      var dd = f.querySelector('[data-predictive-search]');
      if (dd) {
        var hold = function () { f.__pwsHold = true; clearTimeout(f.__pwsT); f.__pwsT = setTimeout(function () { f.__pwsHold = false; }, 900); };
        dd.addEventListener('pointerdown', hold);
        dd.addEventListener('touchstart', hold, { passive: true });
        dd.addEventListener('mousedown', function (e) { if (!e.target.closest('a,button')) return; e.preventDefault(); hold(); });
      }
      f.addEventListener('focusin', function () { fit(f); });
      document.addEventListener('pointerdown', function (e) { if (f.hasAttribute('open') && !f.contains(e.target)) { f.__pwsHold = false; f.close(); } });
      f.addEventListener('input', function () { fit(f); });
      new MutationObserver(function () { if (f.hasAttribute('open')) fit(f); }).observe(f, { attributes: true, attributeFilter: ['open'] });
    }
    function wireAll() { document.querySelectorAll('.pws-field').forEach(wire); }
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('predictive-search').then(wireAll);
      customElements.whenDefined('search-form').then(wireAll);
    }
    wireAll();
    if (window.visualViewport) window.visualViewport.addEventListener('resize', function () {
      document.querySelectorAll('.pws-field[open]').forEach(fit);
    });
    /* phones: bring the results page field up under the header so the dropdown has room above the keyboard */
    document.addEventListener('focusin', function (e) {
      if (window.innerWidth > 749) return;
      var f = e.target.closest && e.target.closest('.pws-field--page');
      if (!f) return;
      setTimeout(function () {
        var hh = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 60;
        var y = f.getBoundingClientRect().top + window.pageYOffset - hh - 8;
        if (Math.abs(window.pageYOffset - y) > 8) window.scrollTo(0, y);
        fit(f);
      }, 250);
    });

    /* playful button: sniff while typing, paw stamp on submit, rotating placeholder */
    var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var PH = ['Search for anything (we dare you)', 'Rusty will sniff it out', 'Try ‘goth blanket’', 'Try ‘ornament for grandma’', 'Cash says: under $40?', 'Something oddly specific...'];
    var PH_FOCUS = 'Type it. Rusty’s already sniffing.';
    var phI = 0;
    document.querySelectorAll('.pws-field').forEach(function (f) {
      var inp = f.querySelector('.pws-input'), form = f.querySelector('form');
      if (!inp || !form) return;
      var last = 0;
      inp.addEventListener('input', function () {
        if (RM) return;
        var now = Date.now();
        if (now - last < 450) return;
        last = now;
        f.classList.remove('is-sniff'); void f.offsetWidth; f.classList.add('is-sniff');
        setTimeout(function () { f.classList.remove('is-sniff'); }, 420);
      });
      inp.addEventListener('focus', function () { if (!inp.value) inp.placeholder = PH_FOCUS; });
      inp.addEventListener('blur', function () { inp.placeholder = PH[phI]; });
      form.addEventListener('submit', function (e) {
        if (e.defaultPrevented || RM || form.__pwsGo || !inp.value.trim() || f.querySelector('[aria-selected="true"] a')) return;
        e.preventDefault();
        form.__pwsGo = true;
        f.classList.add('is-stamp');
        var sub = e.submitter;
        setTimeout(function () {
          if (sub && sub.name) { var h = document.createElement('input'); h.type = 'hidden'; h.name = sub.name; h.value = sub.value; form.appendChild(h); }
          HTMLFormElement.prototype.submit.call(form);
        }, 140);
        setTimeout(function () { f.classList.remove('is-stamp'); form.__pwsGo = false; }, 1500);
      });
    });
    setInterval(function () {
      phI = (phI + 1) % PH.length;
      document.querySelectorAll('.pws-field .pws-input').forEach(function (inp) {
        if (inp.value || document.activeElement === inp || inp.offsetParent === null) return;
        if (RM) { inp.placeholder = PH[phI]; return; }
        inp.classList.add('pws-ph-fade');
        setTimeout(function () { inp.placeholder = PH[phI]; inp.classList.remove('pws-ph-fade'); }, 260);
      });
    }, 3500);

    /* search tracking (v79). Records what people type in the dropdown even when they never press Enter.
       Once per query per session: after a 1.2s pause or on leaving the field (3+ characters), and on tapping
       a suggestion, product, chip or See all. Sends Shopify.analytics.publish('pw_search_typed', ...) for
       custom pixels (Settings > Customer events) and gtag events when GA4 is on the page.
       Queries that look like an email, a phone or card number are never sent. */
    var TRK = 'pws_trk_v1';
    function trkSeen() { try { return JSON.parse(sessionStorage.getItem(TRK) || '[]'); } catch (e) { return window.__pwsSeen || (window.__pwsSeen = []); } }
    function trkMark(k) {
      var a = trkSeen(); a.push(k); if (a.length > 300) a = a.slice(-300);
      try { sessionStorage.setItem(TRK, JSON.stringify(a)); } catch (e) { window.__pwsSeen = a; }
    }
    function trkClean(q) {
      q = (q || '').toLowerCase().replace(/\s+/g, ' ').trim().slice(0, 80);
      if (q.indexOf('@') > -1 || /\d[\d\s-]{5,}\d/.test(q)) return '';
      return q;
    }
    function trkCount(f) { return f.hasAttribute('results') ? f.querySelectorAll('.pwps__pi').length : -1; }
    function trkSend(f, q, type, handle) {
      q = trkClean(q);
      if (q.length < 3) return;
      var key = q + '|' + (type || 'typed') + '|' + (handle || '');
      if (trkSeen().indexOf(key) > -1) return;
      trkMark(key);
      var payload = { query: q, clicked_type: type || '', clicked_handle: handle || '', results_count: trkCount(f) };
      (window.__pwsLog = window.__pwsLog || []).push(payload);
      try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish('pw_search_typed', payload); } catch (e) {}
      try {
        if (typeof window.gtag === 'function') {
          if (!type) window.gtag('event', 'search', { search_term: q });
          else window.gtag('event', 'pw_search_click', { search_term: q, clicked_type: type, clicked_handle: handle || '' });
        }
      } catch (e) {}
    }
    function trkClickInfo(el) {
      var li = el.closest('li,.pwps__foot');
      var type = 'other';
      if (el.classList.contains('pwps__all')) type = 'see_all';
      else if (li && li.classList.contains('pwps__qi--pin')) type = 'pinned';
      else if (li && li.classList.contains('pwps__qi')) type = 'suggestion';
      else if (li && li.classList.contains('pwps__pi')) type = 'product';
      else if (li && li.classList.contains('pwps__ci')) type = /\/pages\/|\/blogs\//.test(el.getAttribute('href') || '') ? 'page' : 'collection';
      var handle = '';
      if (el.href) {
        try {
          var u = new URL(el.href, location.origin);
          handle = type === 'suggestion' ? (u.searchParams.get('q') || '') : u.pathname.split('/').filter(Boolean).slice(-1)[0] || '';
        } catch (e) {}
      }
      return { type: type, handle: handle.slice(0, 120) };
    }
    /* keep Shopify's search attribution params on every dropdown link (our pinned rows and re-ordered tiles included) */
    function trkTag(el, q) {
      if (!el.href || !q) return;
      try {
        var u = new URL(el.href, location.origin);
        if (u.origin !== location.origin || u.searchParams.has('_psq')) return;
        var list = el.closest('ul');
        var pos = list ? Array.prototype.indexOf.call(list.children, el.closest('li')) + 1 : 1;
        u.searchParams.set('_pos', String(pos > 0 ? pos : 1));
        u.searchParams.set('_psq', q);
        u.searchParams.set('_ss', 'e');
        u.searchParams.set('_v', '1.0');
        el.href = u.pathname + u.search + u.hash;
      } catch (e) {}
    }
    document.querySelectorAll('.pws-field').forEach(function (f) {
      var inp = f.querySelector('.pws-input'), t = null, typed = false;
      if (!inp) return;
      inp.addEventListener('input', function () {
        typed = true;
        clearTimeout(t);
        t = setTimeout(function () { trkSend(f, inp.value); }, 1200);
      });
      inp.addEventListener('blur', function () { clearTimeout(t); if (typed) trkSend(f, inp.value); });
      var onPick = function (e) {
        var el = e.target.closest && e.target.closest('.pwps a[href], .pwps button.pwps__all');
        if (!el) return;
        var q = trkClean(inp.value);
        if (el.tagName === 'A') trkTag(el, q);
        var info = trkClickInfo(el);
        trkSend(f, inp.value);
        trkSend(f, inp.value, info.type, info.handle);
      };
      f.addEventListener('pointerdown', onPick, true);
      f.addEventListener('click', onPick, true);
      var form = f.querySelector('form');
      if (form) form.addEventListener('submit', function () { clearTimeout(t); trkSend(f, inp.value); }, true);
    });

    /* "/" to search */
    document.addEventListener('keydown', function (e) {
      if (e.key !== '/' || e.metaKey || e.ctrlKey || e.altKey) return;
      var t = e.target;
      if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
      var fields = document.querySelectorAll('.pws-field .pws-input');
      for (var i = 0; i < fields.length; i++) {
        if (fields[i].offsetParent !== null) { e.preventDefault(); fields[i].focus(); fields[i].select(); return; }
      }
    });
  });
})();
